import { computed } from 'vue-demi';
import { state } from './../../store/modules/ads_creative/state';
import mutations from './../../store/modules/ads_creative/mutations';
import { MaterialSource, videoStage } from './../../const/media';
import adsCreative from './../../store/modules/ads_creative/index';
import identityStore from './../../store/modules/identity/index';
const useVideoState = (emit): Record<string, any> => {
  const videoSource = computed(() => state.identity.activeSource.value);
  const video = computed(() => state.identity.creativeInfo.value);
  const stage = computed(() => state.creative.videoStage.value);
  const info = computed(() => state.identity.mediaInfo.value);
  const getLabelForUpload = (): { fileName: any; post: any; informationLine: any; src: any } => {
    if (!video.value) {
      return {
        src: '',
        post: '',
        fileName: '',
        informationLine: '',
      };
    }
    const curVerticalVideo = video.value;
    const src = atob(curVerticalVideo?.main_url || '');
    const post = curVerticalVideo?.cover_url || '';
    const fileName = info?.value?.videoInfo[0]?.file?.name || curVerticalVideo?.name || '';
    const height = curVerticalVideo?.height;
    const { width } = curVerticalVideo;
    const { duration } = curVerticalVideo;
    const informationLine = `${duration} | ${width} * ${height}`;
    return {
      src,
      post,
      fileName,
      informationLine,
    };
  };
  const getLabelForTikTokVideo = (): { fileName: any; post: any; informationLine: any; src: any } => {
    const curVideo = state.identity.selectedVideo.value;
    const src = curVideo?.video_info?.play_url || '';
    const post = curVideo?.video_info?.cover_url || '';
    const fileName = curVideo?.item_id;
    const height = curVideo?.video_info?.height || '';
    const width = curVideo?.video_info?.width || '';
    const duration = curVideo?.video_info?.duration || '';
    const informationLine = `${duration} | ${width} * ${height}`;
    return {
      src,
      post,
      fileName,
      informationLine,
    };
  };
  const onDelete = (): void => {
    const activeSource = computed(() => adsCreative.state.identity.activeSource.value);
    if (activeSource.value === MaterialSource.TIKTOK_VIDEO) {
      mutations.setTitle('');
    } else {
      adsCreative.mutations.setLocalDisplayName(adsCreative.getters.identityFormData.value.displayName);
      adsCreative.mutations.setLocalAvatarIcon(adsCreative.getters.identityFormData.value.imageInfo);
    }
    mutations.setClearCreativeData();
    mutations.setClearSelectedVideo();
    mutations.setVideoStage(videoStage.INIT);
    mutations.setActiveSource(-1);
    mutations.setUsingTikTokAccountUnderOwner(adsCreative.getters.userHasOwnedTikTokAccount.value);
    identityStore.mutations.setUseTikTokIdentity(adsCreative.getters.userHasOwnedTikTokAccount.value);

    if (adsCreative.getters.userHasOwnedTikTokAccount.value) {
      adsCreative.mutations.setCustomIdentity(adsCreative.getters.identityFormData.value.ownedTikTokAccount);
      adsCreative.mutations.setDisplayName(
        adsCreative.getters.identityFormData.value.ownedTikTokAccount.display_name,
      );
      adsCreative.mutations.setImageInfo(
        adsCreative.getters.identityFormData.value.ownedTikTokAccount.avatar_icon,
      );
    } else {
      adsCreative.mutations.setDisplayName(adsCreative.getters.identityFormData.value.localDisplayName);
      adsCreative.mutations.setImageInfo(adsCreative.getters.identityFormData.value.localAvatarIcon);
    }
    emit('video-delete');
  };
  const onDeleteForGenerateVideo = () => {
    onDelete();
    emit('video-delete-in-progress');
  };

  return {
    stage,
    onDelete,
    videoSource,
    verticalVideo: video,
    getLabelForUpload,
    getLabelForTikTokVideo,
    onDeleteForGenerateVideo,
  };
};

export default useVideoState;
